import React__default, { useState, useEffect } from 'react';
import { useCheckoutContext } from '@zooplus/checkout-state';
import FallbackComponent from '../ErrorFallback.js';
import SentryErrorBoundary from '../SentryErrorBoundary.js';
import { FodBanner } from './FodBanner.js';
import '../../node_modules/@zooplus/commons-lang/dist/es/gen/lang.js';
import { SiteProvider } from '../../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import { findSiteByDomain } from '../../node_modules/@zooplus/commons-lang/dist/es/services/langService.js';
import '../../node_modules/@zooplus/commons-lang/dist/es/hooks/use-translation.js';

const AutoshipmentFodBanner = () => {
    const { checkoutSubscriptionState, appConfig } = useCheckoutContext('autoshipment-component');
    const [fodPercentage, setFodPercentage] = useState(undefined);
    const [eligibleFodArticles, setEligibleFodArticles] = useState(false);
    const siteDomain = appConfig?.shop.domain;
    const locale = appConfig?.locale;
    useEffect(() => {
        if (checkoutSubscriptionState?.articles) {
            const articles = (checkoutSubscriptionState?.articles || []).filter((article) => article.subscriptionDetails?.firstOrderDiscount === true &&
                article.subscriptionDetails?.displaySwitch);
            if (articles.length) {
                setEligibleFodArticles(true);
                setFodPercentage(Math.max(...articles.map((article) => article.subscriptionDetails.percentage)));
            }
            else {
                setEligibleFodArticles(false);
            }
        }
    }, [checkoutSubscriptionState?.articles]);
    const site = findSiteByDomain(siteDomain);
    return (React__default.createElement(React__default.Fragment, null, eligibleFodArticles && (React__default.createElement(SentryErrorBoundary, { FallbackComponent: FallbackComponent },
        React__default.createElement(SiteProvider, { site: site, locale: locale },
            React__default.createElement(FodBanner, { fodPercentage: fodPercentage }))))));
};

export { AutoshipmentFodBanner };
//# sourceMappingURL=AutoshipmentFodBanner.js.map
